import Container from './StudioSearchBar.container';
import StudioSearchBar from './StudioSearchBar';

export default Container(StudioSearchBar);
